/**
 * The helpers in this file are meant for internal use.
 */
import {
  SegmentType,
  DateSegment as DateSegmentType,
} from 'react-stately/useDateFieldState';
import { getPlaceholder } from './placeholders';

/**
 * The interface from `useDateFieldState` to clear the input is not ideal. We
 * have to manually clear each segment type.
 */
export const segmentTypes: SegmentType[] = [
  'day',
  'hour',
  'minute',
  'second',
  'era',
  'year',
  'month',
  'dayPeriod',
  'literal',
  'timeZoneName',
];

export const isAnyModified = (segments: DateSegmentType[]): boolean =>
  segments
    .map(({ type, isPlaceholder }) => {
      // type "literal" refers to the segment containing the non-editable separator
      return type !== 'literal' && !isPlaceholder;
    })
    .some((isModified) => isModified);

/**
 * Check out the `getPlaceholder` function's description for
 * an explanation.
 */
export const setPlaceholderLanguage = (
  segment: DateSegmentType,
  locale: string
): DateSegmentType => {
  const placeholder = getPlaceholder(segment.type, segment.text, locale);

  return {
    ...segment,
    text: segment.isPlaceholder ? placeholder : segment.text,
    placeholder,
  };
};
